<div class="test-page-container">
  <h1>Angular Material Test Page</h1>
  <p>Ez az oldal a különböző Material komponensek tesztelésére szolgál iframe és webview környezetben.</p>

  <div class="test-section">
    <h3>mat-slide-toggle</h3>
    <mat-slide-toggle [(ngModel)]="toggleValue">Slide me!</mat-slide-toggle>
    <p>Érték: {{toggleValue}}</p>
  </div>

  <div class="test-section">
    <h3>mat-checkbox</h3>
    <mat-checkbox [(ngModel)]="checkboxValue">Check me!</mat-checkbox>
    <p>Érték: {{checkboxValue}}</p>
  </div>

  <div class="test-section">
    <h3>mat-select (Dropdown)</h3>
    <mat-form-field appearance="fill">
      <mat-label>Válassz egy opciót</mat-label>
      <mat-select [(ngModel)]="selectValue">
        <mat-option value="option1">Opció 1</mat-option>
        <mat-option value="option2">Opció 2</mat-option>
        <mat-option value="option3">Opció 3</mat-option>
      </mat-select>
    </mat-form-field>
    <p>Kiválasztva: {{selectValue}}</p>
  </div>

  <div class="test-section">
    <h3>mat-datepicker (Dátum választó)</h3>
    <mat-form-field appearance="fill">
      <mat-label>Válassz dátumot</mat-label>
      <input matInput [matDatepicker]="picker" [(ngModel)]="dateValue">
      <mat-hint>MM/DD/YYYY</mat-hint>
      <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
    <p>Kiválasztott dátum: {{dateValue | date:'yyyy-MM-dd'}}</p>
  </div>

  <div class="test-section">
    <h3>mat-slider</h3>
    <mat-slider min="0" max="100" step="1" discrete>
      <input matSliderThumb [(ngModel)]="sliderValue">
    </mat-slider>
    <p>Érték: {{sliderValue}}</p>
  </div>

  <div class="test-section">
    <h3>mat-radio-group</h3>
    <mat-radio-group [(ngModel)]="radioValue">
      <mat-radio-button value="1">Első</mat-radio-button>
      <mat-radio-button value="2">Második</mat-radio-button>
    </mat-radio-group>
    <p>Kiválasztva: {{radioValue}}</p>
  </div>

  <div class="test-section">
    <h3>mat-input</h3>
    <mat-form-field appearance="fill">
      <mat-label>Szövegmező</mat-label>
      <input matInput [(ngModel)]="inputValue" placeholder="Írj valamit...">
    </mat-form-field>
    <p>Beírt szöveg: {{inputValue}}</p>
  </div>

  <div class="test-section">
    <h3>mat-button</h3>
    <button mat-raised-button color="primary">Primary Button</button>
    <button mat-stroked-button color="accent">Stroked Button</button>
  </div>
</div>
